import React, { useCallback, useEffect, useState } from 'react';
import { IRenderingEngine, QuestionResponse } from '../interfaces/index.type';
import { fetchSelectedQption } from '../actions';
import { Checkbox, Typography } from '@navi/web-ui/lib/primitives';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import styles from '@cp/pages/CaseDetails/feedbackForm/index.module.scss';

const CheckboxOptions: React.FC<IRenderingEngine> = props => {
  const {
    question,
    register,
    error,
    source,
    lan,
    customerId,
    toggleLoading,
    interactionType,
    setValue,
    getValue,
    unregister,
    clearErrors,
    ...remainingProps
  } = props;
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const { options, mandatory, referenceId, text } = question;

  useEffect(() => {
    if (options?.length) {
      const selectedOptions = options?.filter(option => option?.metadata?.isDefault);
      if (selectedOptions?.length) {
        setValue(
          `${source}_${referenceId}_checkboxOption`,
          selectedOptions.map(option => option.referenceId)
        );
        setSelectedOptions(selectedOptions.map(option => option.referenceId));
      }
    }
    return () => {
      setValue(`${source}_${referenceId}_checkboxOption`, []);
    };
  }, [options]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (selectedOptions.includes(event.target.value)) {
      const filteredOptions = selectedOptions.filter(option => option !== event.target.value);
      setSelectedOptions(filteredOptions);
      return;
    }
    const selectedId = event?.target?.value;
    setSelectedOptions(prev => [...prev, selectedId]);
    toggleLoading(true);
    fetchSelectedQption(lan, customerId, event.target.value, successCallback, interactionType);
  };

  const successCallback = useCallback((res: Array<QuestionResponse>) => {
    toggleLoading(false);
  }, []);

  useEffect(() => {
    return () => {
      setValue(`${source}_${referenceId}_checkboxOption`, []);
      unregister(`${source}_${referenceId}_checkboxOption`);
      clearErrors(`${source}_${referenceId}_checkboxOption`);
    };
  }, []);

  useEffect(() => {
    if (selectedOptions) {
      setValue(`${source}_${referenceId}_checkboxOption`, selectedOptions);
    }
  }, [selectedOptions]);

  return (
    <div key={`${source}_${referenceId}_${text}_${selectedOptions}`}>
      <Typography variant={'p4'} as={'p'}>
        {text}{' '}
        {mandatory && (
          <sup>
            <RequiredIcon />
          </sup>
        )}
      </Typography>
      <div className="flex flex-wrap gap-4">
        {options?.map(option => {
          return (
            <div key={option.referenceId} className="w-[40%]">
              <Checkbox
                {...register(`${source}_${referenceId}_checkboxOption`, {
                  required: mandatory,
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    handleCheckboxChange(e);
                  }
                })}
                key={option.referenceId}
                value={option.referenceId}
                title={option.text}
                checked={selectedOptions.includes(option.referenceId)}
              />
            </div>
          );
        })}
        {error?.[`${source}_${referenceId}_checkboxOption`] && (
          <Typography variant="p5" className={styles.errorText}>
            {`Please select at least one option`}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default CheckboxOptions;
